import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Column from 'components/Column';
import { OBCard } from 'features/Bento/components';
import AppPreviewNotification from 'features/Onboarding/legacy/components/AppPreviewNotification';
import DownloadShineCard from 'features/Onboarding/legacy/components/DownloadShineCard';

import locales from './locales';
import {
  AppPreviewNotificationWrapper,
  BulletDivider,
  InfoText,
  StepName,
} from './styles';
import { CommonLayoutProps } from './types';

const NextStepsCommonLayout: FC<CommonLayoutProps> = ({
  imageSrc,
  onSuccessfulSmsSend,
  onWhatIsNextLinkPress,
  stepDescription,
  stepName,
  withAppDownloadCard = true,
  ...otherProps
}) => {
  const content = (
    <Box paddingBottom="space-32">
      <Column alignItems="center">
        <StepName>{stepName}</StepName>

        <InfoText>{stepDescription}</InfoText>
        {'infoSentByMail' in otherProps ? (
          <>
            <BulletDivider />
            <InfoText>
              {locales.formatString(otherProps.infoSentByMail, {
                email: otherProps.email,
              })}
            </InfoText>
          </>
        ) : null}

        <Button
          icon="chevron-right"
          marginTop="space-48"
          onClick={onWhatIsNextLinkPress}
          variant="inline-primary"
        >
          {locales.seeWhatIsNext}
        </Button>
      </Column>
    </Box>
  );

  return withAppDownloadCard ? (
    <DownloadShineCard
      onSuccessfulSend={onSuccessfulSmsSend}
      previewAppContent={
        <AppPreviewNotificationWrapper>
          <AppPreviewNotification />
        </AppPreviewNotificationWrapper>
      }
      topContent={content}
    />
  ) : (
    <OBCard>{content}</OBCard>
  );
};

export default NextStepsCommonLayout;
